<template>
  <div class="content">
    <settings-menu></settings-menu>
    <div class="settings-body">
      <div class="settings-body-inner">
        <div class="row">
          <div class="col-lg-6">
            <div class="s-block">
              <div class="s-block-header">Stripe Account</div>
              <div class="s-block-body">
                <div class="billing-info-wrap">
                  <img class="stripe-img" v-bind:src="require(`./stripe_logo.png`)">
                  <div v-if="tasks && tasks.tasks && tasks.tasks.has_stripe_connect" class="billing-info">
                    <div class="sub-title">Stripe Connected</div>
                    <div v-if="false">Stripe Processing Fee</div>
                    <div v-if="false" class="sm-text">2.9% + $0.30</div>
                    <a href="https://dashboard.stripe.com/" target="_blank">Stripe Dashboard</a>
                  </div>
                  <div v-else class="billing-info">
                    <a :href="connectStripeLink" target="_blank">Create or Link Stripe Account</a>
                    <p>Connect an existing Stripe account or create a new one to accept Donations with Harness</p>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="s-block">
              <div class="s-block-header">Nonprofit Discount</div>
              <div class="s-block-body d-block">
                <div class="contacts-list">
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Stripe Discounted Rate
                        <div class="info">Stripe offers a discounted processing fee for qualifying
                          nonprofit organizations. Stripe's custom charity pricing structure is only applicable for
                          organizations accepting donations (e.g. not selling products or tickets), and by receiving
                          these discounted rates, your organization will be agreeing to primarily use your Stripe
                          account for this purpose.
                          If your organization has nonprofit status and will be processing 80% or more of donation
                          payments on Stripe, email nonprofit@stripe.com with the following information:

                          <ul class="list-disc px-8 my-2">
                            <li>Your EIN, or a letter from the IRS designating your 501(c)(3) status</li>
                            <li>Confirmation of the primary email address associated with your Stripe account</li>
                            <li>Confirmation that greater than 80% of your payment volume will be tax deductible
                              donations.
                            </li>
                            <li>Some examples of non-eligible donations include: membership fees, tuition payments,
                              ticket sales, registration fees, and auction payments.
                            </li>
                          </ul>

                          <a href="mailto:nonprofit@stripe.com?subject=Applying%20for%20the%20Stripe%20Fee%20Discount%20for%20Nonprofit%20Organizations&body=Hi%20Stripe%2C%0D%0A%0D%0AI'm%20reaching%20out%20on%20behalf%20of%20%5Borganization_name%5D%20in%20regards%20to%20your%20Stripe%20Fee%20Discount%20for%20Nonprofits.%0D%0A%0D%0AI%20have%20provided%20the%20information%20requested%20below%3A%0D%0A%0D%0AEIN%3A%20%5BInsert_EIN%5D%0D%0AEmail%20Address%20for%20Stripe%3A%20%5BInsert_Email%5D%0D%0A%0D%0AI%20CONFIRM%20that%2080%25%20of%20our%20payment%20volume%20will%20be%20tax%20deductible%20donations.%0D%0A">Apply
                            for Discount via Email</a>

                          <hr style="border: 1px solid #e6eaee;">Have you been approved for the Nonprofit Discount by Stripe? <a href="mailto:help@harnessapp.com?subject=We're%20Approved%20for%20the%20Stripe%20Nonprofit%20Processing%20Fee%20Discount&body=Hi%20Harness%2C%0D%0A%0D%0AWe're%20reaching%20out%20to%20let%20you%20know%20that%20we%20have%20been%20approved%20for%20the%20Nonprofit%20Processing%20Fee%20Discount%20of%202.2%25%20%2B%20%240.30.%20If%20you%20could%20please%20update%20this%20on%20our%20Harness%20platform%20that%20would%20be%20great.">Let us know</a>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import SettingsMenu from './menu.vue';
  import {mapState} from 'vuex';
  import config from '../../../public/harness_config.json';
  import {getToken} from '@/utils/api';

  export default {
    name: 'Stripe',
    metaInfo: {
      title: 'Settings - Stripe',
    },
    components: {
      SettingsMenu,
    },
    methods: {
      parseJwt(token) {
        if (token.split('.')[1]) {
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace('-', '+').replace('_', '/');
          return JSON.parse(window.atob(base64));
        }
        return false;
      },
    },
    computed: {
      ...mapState({
        adminInfo: state => state.auth.adminInfo,
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
        tasks: state => state.tasks,
      }),
      connectStripeLink() {
        if (!this.adminInfo || !this.activeCharityInfo) {
          return '';
        }
        const stripeConnectRedirectUri = `${config.scheme}://${config.url}/${config.api_version}/webhook/stripe/connect`;
        return `https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write&client_id=${config.stripe.client_id ||
        'ca_7euxOPoYXWLO8F377XOirFEYKTOJS1uP'}&state=${this.parseJwt(
          getToken()).client_id}.${this.activeCharityInfo.activeCharityId}&redirect_uri=${stripeConnectRedirectUri}`;
      },
    },
    data() {
      return {
        handler: null,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .billing-info-wrap {
    .stripe-img {
      width: 254px;
      max-width: 100%;
      height: auto;
      position: absolute;
      left: 0;
      top: -77px;
      border-radius: 8px;
      padding: 20px 30px;
    }
    .billing-info {
      margin-left: 250px;
    }
  }
  .settings-body .s-block .table td:first-of-type {
    text-align: left;
    padding: 16px 20px;
  }
</style>
